import { NgModule, LOCALE_ID, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NbThemeModule, NbLayoutModule, NbSidebarModule, NbMenuModule, NbIconModule, NbUserModule, NbActionsModule, NbSearchModule, NbContextMenuModule, NbButtonModule, NbSelectModule, NbDialogModule, NbDatepickerModule, NbCardModule, NbInputModule, NbToastrModule, NbListModule, NbBadgeModule, NbSpinnerModule } from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { NbDateFnsDateModule } from '@nebular/date-fns';
import { PageComponent } from './pages/page.component';
import { ReactiveFormsModule } from '@angular/forms';
import { AuthModule } from './auth/auth.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AccessTokenInterceptor } from './interceptors/access-token.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { ExternsModule } from './pages/externs/externs.module';
import { CrmJournalModule } from './pages/crm-journal/crm-journal.module';
import { UsersModule } from './pages/users/users.module';
import { IconService } from './services/icon.service';
import { LogoutComponent } from './pages/logout/logout.component';
import { CompanySelectorDialogComponent } from './pages/company-selector-dialog/company-selector-dialog.component';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

registerLocaleData(localeFr);

const NB_MODULES = [
  NbLayoutModule,
  NbMenuModule,
  NbUserModule,
  NbActionsModule,
  NbSearchModule,
  NbSidebarModule,
  NbContextMenuModule,
  NbButtonModule,
  NbSelectModule,
  NbIconModule,
  NbEvaIconsModule,
  NbThemeModule.forRoot({ name: 'qwintal' }),
  NbLayoutModule,
  NbEvaIconsModule,
  NbSidebarModule.forRoot(),
  NbMenuModule.forRoot(),
  NbDialogModule.forRoot(),
  NbDatepickerModule.forRoot(),
  NbCardModule,
  ReactiveFormsModule,
  NbInputModule,
  NbDateFnsDateModule.forRoot({ format: 'dd/MM/yyyy' }),
  NbToastrModule.forRoot(),
  NbListModule,
  NbBadgeModule,
  NbSpinnerModule
];

export function initializeApp(iconService: IconService): () => Promise<void> {
  return (): Promise<void> => iconService.registerIcons();
}

@NgModule({
  declarations: [
    AppComponent,
    PageComponent,
    LogoutComponent,
    CompanySelectorDialogComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NB_MODULES,
    AuthModule,
    ExternsModule,
    CrmJournalModule,
    UsersModule
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideCharts(withDefaultRegisterables()),
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: HTTP_INTERCEPTORS, useClass: AccessTokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    provideAppInitializer(() => {
      const initializerFn = initializeApp(inject(IconService));
      return initializerFn();
    })
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
